const disabledLocalesForVat = ["en-IN" /* enIN */, "en-AU" /* enAU */, "en-SG" /* enSG */, "en-NZ" /* enNZ */, "en-US" /* enUS */, "es-US" /* esUS */, "en-CA" /* enCA */, "fr-CA" /* frCA */];
const enabledLocalesForShippingMessage = ["de-DE" /* deDE */];
const DEFAULT_LOCALE = "en-US" /* enUS */;

export { DEFAULT_LOCALE, disabledLocalesForVat, enabledLocalesForShippingMessage };
//# sourceMappingURL=ep-pricing-esm-constants-locale.js.map
